import type { Languages } from '@s4l/i18n/types/Languages'
import type { Config } from '../../_config'
import { FactoryHeader } from '../../_headers/FactoryHeaders'
import { DomainError } from '../../_kernel/DomainError'
import { ErrorsCode } from '../../_kernel/ErrorsCode'
import type { Affiliate } from '../domain/Affiliate'
import { Language } from '../domain/Language'
import type { Market } from '../domain/Market'
import type { PartialSearch } from '../domain/PartialSearch'
import type { SharedRepository } from '../domain/SharedRepository'
import type { Source } from '../domain/Source'
import type { FeatureFlag } from '../domain/FeatureFlag'

export class HeaderSharedRepository implements SharedRepository {
  static create({ config }: { config: Config }) {
    return new HeaderSharedRepository(config)
  }

  constructor(private readonly config: Config) {}

  async source(): Promise<Source> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async market(): Promise<Market> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async language() {
    const header = await FactoryHeader.create({ config: this.config }).header()

    const [error, acceptedLanguage] = header.getAcceptedLanguages<Languages>()

    if (error) return Language.empty()
    if (acceptedLanguage.localeWithRegion) {
      const locale = Language.createOrEmpty({
        value: acceptedLanguage.localeWithRegion.replace('-', '_') as Languages,
      })

      if (!locale.isEmpty()) return locale
    }

    if (!acceptedLanguage.locale) return Language.empty()

    return Language.create({ value: acceptedLanguage.locale })
  }

  async partialSearch(): Promise<PartialSearch> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async affiliate(): Promise<Affiliate> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }

  async featureFlagByName(): Promise<FeatureFlag> {
    throw DomainError.withCodes(ErrorsCode.FORBIDDEN_REPOSITORY_METHOD)
  }
}
